import { render, staticRenderFns } from "./BloqueMapPoli.vue?vue&type=template&id=9f25dbb4"
import script from "./BloqueMapPoli.vue?vue&type=script&lang=js"
export * from "./BloqueMapPoli.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports